import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const PricingComponent = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
    
        minHeight: "20vh",
        backgroundColor: "",
        fontFamily: "'Work Sans', sans-serif",
        textAlign: "center",
        padding: "10px 20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Pricing Card */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, type: "spring" }}
        style={{
          maxWidth: "400px",
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
          padding: "20px",
        }}
      >
        {/* Pricing Header */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "#333",
            marginBottom: "20px",
            fontFamily: "'Work Sans', sans-serif",
          }}
        >
          $8 USD / Month
        </Typography>

        {/* Features List */}
        <Box sx={{ textAlign: "left", marginBottom: "20px" }}>
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              fontSize: "16px",
              lineHeight: 1.8,
              marginBottom: "10px",
              fontFamily: "'Work Sans', sans-serif",
            }}
          >
            - Unlimited access to all news pages.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              fontSize: "16px",
              lineHeight: 1.8,
              marginBottom: "10px",
              fontFamily: "'Work Sans', sans-serif",
            }}
          >
            - Unlimited access to all technical indicators and filtering options.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              fontSize: "16px",
              lineHeight: 1.8,
              marginBottom: "10px",
              fontFamily: "'Work Sans', sans-serif",
            }}
          >
            - View the entire NYSE stock market sorted.
          </Typography>
        </Box>

        {/* Free Trial Button */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#5e60ce",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "16px",
            fontFamily: "'Work Sans', sans-serif",
            padding: "10px 20px",
            borderRadius: "8px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#4e50be",
            },
          }}
          onClick={() => navigate("/ManageSubscription")}
        >
          Subscribe Now
        </Button>
      </motion.div>
    </Box>
  );
};

export default PricingComponent;
